export default __webpack_public_path__ + "static/media/empyrean_wordmark.d02e334f.svg";